"use client";

import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function AOSInit() {
  useEffect(() => {
    // Inicializar en idle para no competir con la hidratación (TBT),
    // y desactivar animaciones en móvil: en pantallas pequeñas el costo
    // de los reflows de AOS supera el beneficio visual.
    const init = () =>
      AOS.init({
        duration: 700,
        easing: "ease-out-quart",
        once: true,
        mirror: false,
        offset: 80,
        disable: () => window.innerWidth < 1024,
      });

    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    let idleId: number | undefined;
    if (typeof window.requestIdleCallback === "function") {
      idleId = window.requestIdleCallback(init, { timeout: 2000 });
    } else {
      timeoutId = setTimeout(init, 200);
    }

    const handleResize = () => AOS.refresh();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (idleId !== undefined) window.cancelIdleCallback(idleId);
      if (timeoutId !== undefined) clearTimeout(timeoutId);
    };
  }, []);

  return null;
}
